import { DBSchema } from "idb";

export const CACHE_IDB_CONFIG = {
    name: 'TradingCacheDB',
    version: 1,
    storeName: 'aiBacktestData',
}

export const CACHE_IDB_STORE_NAME = 'aiBacktestData';

export interface CacheDB extends DBSchema {
    aiBacktestData: {
        key: string; // Unique identifier for each dataset
        value: any; // Compressed JSON data as a string
    };
};